// Single source of truth for all runtime environment variables.
// All process.env.REACT_APP_* reads are centralised here so that:
//   - TypeScript catches typos at the call site
//   - PR 5 (CRA removal) only needs to edit this one file to switch to import.meta.env.VITE_*
//
// Works in all three build contexts:
//   CRA (webpack)   — webpack replaces process.env.REACT_APP_* at build time
//   Vite dev        — processEnvShimPlugin in vite.config.ts injects window.process.env
//   Vite prod build — vite:define replaces process.env.REACT_APP_* at build time

export const env = {
  // Auth0
  auth0Audience: process.env.REACT_APP_AUTH0_AUDIENCE ?? '',
  auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? '',
  auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN ?? '',

  // API endpoints
  endPoint: process.env.REACT_APP_END_POINT ?? '',
  willieEndPoint: process.env.REACT_APP_WILLIE_END_POINT ?? '',
  connectEndPoint: process.env.REACT_APP_CONNECT_END_POINT ?? '',
  connectInternalEndPoint:
    process.env.REACT_APP_CONNECT_INTERNAL_END_POINT ?? '',
  connectInternalV1Url: process.env.REACT_APP_CONNECT_INTERNAL_V1_URL ?? '',
  graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT ?? '',
  phraseexEndpoint: process.env.REACT_APP_PHRASEEX_ENDPOINT ?? '',
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL ?? '',
  logoutUrl: process.env.REACT_APP_LOGOUT_URL ?? '',
  promptManagementEndpoint:
    process.env.REACT_APP_PROMPT_MANAGEMENT_ENDPOINT ?? '',

  // Regional URLs (JSON strings — parse at call site)
  regionalReportingUrls: process.env.REACT_APP_REGIONAL_REPORTING_URLS ?? '',
  regionalIngestionUrls: process.env.REACT_APP_REGIONAL_INGESTION_URLS ?? '',
  dataSourcesUrls: process.env.REACT_APP_DATA_SOURCES_URLS ?? '',
  personalizationLanguage: process.env.REACT_APP_PERSONALIZATION_LANGUAGE ?? '',

  // Feature services
  launchDarklyId: process.env.REACT_APP_LAUNCH_DARKLY_ID ?? '',
  intercomAppId: process.env.REACT_APP_INTERCOM_APP_ID ?? '',
  logrocketApp: process.env.REACT_APP_LOGROCKET_APP ?? '',
  mockServer: process.env.REACT_APP_MOCK_SERVER ?? '',

  // Facebook integration
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID ?? '',
  facebookConnectUrl: process.env.REACT_APP_FACEBOOK_CONNECT_URL ?? '',
  fullFacebookPermissions:
    process.env.REACT_APP_FULL_FACEBOOK_PERMISSIONS ?? '',
  minFacebookPermissions: process.env.REACT_APP_MIN_FACEBOOK_PERMISSIONS ?? '',

  // Metabase
  metabaseAccountDashboardId:
    process.env.REACT_APP_METABASE_ACCOUNT_DASHBOARD_ID ?? '',
  metabaseCampaignDashboardId:
    process.env.REACT_APP_METABASE_CAMPAIGN_DASHBOARD_ID ?? '',

  // Display / formatting
  defaultDateFormat: process.env.REACT_APP_DEFAULT_DATE_FORMAT ?? '',
  defaultDateTimeFormat: process.env.REACT_APP_DEFAULT_DATE_TIME_FORMAT ?? '',

  // App config
  environment: process.env.REACT_APP_ENVIRONMENT ?? '',
  isDevelopment: process.env.REACT_APP_IS_DEVELOPMENT ?? '',
  enableMocks: process.env.REACT_APP_ENABLE_MOCKS ?? '',
  underConstruction: process.env.REACT_APP_UNDER_CONSTRUCTION ?? '',
  sfmcRedirect: process.env.REACT_APP_SFMC_REDIRECT ?? '',
  baseUrl: process.env.REACT_APP_BASE_URL ?? '',
} as const
